<template>
  <div>
    <div
      ref="title"
      :style="`width:100%; height:${ height ? height : '400px' };`"
    ></div>
    <div v-if="canClick">
      <b-modal v-model="activeSth" :width="640">
        <LateTable
        :table_title="tableTitle"
        :data_driver="tableDataDriver"
        />
      </b-modal>
    </div>
  </div>
</template>

<script>
import LateTable from '@/components/LateTable.vue'

import * as echarts from 'echarts'

export default {
  components: {
    LateTable
  },
  props: ['title', 'option', 'height', 'canClick', 'listOfDriver'],
  data () {
    return {
      chart: null,
      activeSth: false,
      tableDataDriver: [],
      tableTitle: ''
    }
  },
  watch: {
    option: {
      handler (val) {
        if (val) {
          try {
            this.chart.setOption(val)
          } catch (error) {
            // console.log('error', error)
          }
        }
      }
    }
  },
  async mounted () {
    this.initChart()
    // console.log('click param', this.canClick)
    if (this.canClick === true) {
      this.onClickChart()
    }
  },
  methods: {
    initChart () {
      this.chart = echarts.init(this.$refs.title)
      this.chart.setOption(this.option)
    },
    onClickChart () {
      // latesDriverDaily.items
      this.listOfDriverlocal = this.listOfDriver.latesDriverDaily.items
      this.chart.on('click', 'series', (params) => {
        // console.log(params)
        if (params.name === 'Late') {
          this.activeSth = !this.activeSth
          const _list = []
          for (const ele of this.listOfDriverlocal) {
            if (ele.late) {
              _list.push({ name: ele.driverName, countLate: ele.late, branch: ele.origin })
            }
          }
          this.tableDataDriver = _list.sort((a, b) => (b.countLate - a.countLate))
          this.tableTitle = 'Late Driver'
          // console.log(this.tableDataDriver)
        }
        if (params.name === 'On-time') {
          this.activeSth = !this.activeSth
          const _list = []
          for (const ele of this.listOfDriverlocal) {
            if (ele.notLate) {
              _list.push({ name: ele.driverName, countLate: ele.notLate, branch: ele.origin })
            }
          }
          this.tableDataDriver = _list.sort((a, b) => (b.countLate - a.countLate))
          this.tableTitle = 'On-time Driver'
          // console.log(this.tableDataDriver)
        }
      })
    }
  }
}
</script>
